export default "__VITE_ASSET__DrTCSMdu__"